import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'firstLetterLowercase'
})
export class FirstLetterLowercasePipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    if (typeof value !== 'string') {
      return '';
    }
    return value.charAt(0).toLowerCase() + value.slice(1);
  }

}
